import React, { FC, useEffect, useState, useRef } from 'react'
import {
  Col,
  Container,
  Row,
  Tab,
  Nav,
  Form,
  Spinner,
  Button,
  Pagination,
} from 'react-bootstrap'
import AOS from 'aos'
import { Searchicon2 } from 'components/Common/Icon'
import Link from 'next/link'
import axios from 'axios'
import { useDebounce } from 'use-debounce'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import { useRouter } from 'next/router'

interface BlogCategory {
  _id: number
  title: string
  slug: string
}
interface BlogType {
  _id: number
  title: string
  date?: string
  description?: string | undefined
  image?: string
  slug?: string | undefined
  author: string
  categories: [BlogCategory]
  createdOn: number
}

const BlogListSection: FC<BlogType | BlogCategory> = () => {
  function createMarkup(c) {
    return { __html: c }
  }

  const ref = useRef<null | HTMLElement>(null)
  const [Loading, setLoading] = useState(true)

  const router = useRouter()
  // const slug = router.query.slug
  const { slug } = router.query
  const [blogData, setBlogData] = useState([])
  const [categoryList, setCategoryList] = useState([])
  const [getcat, setGetCat] = useState('')
  const [getCatAll, setGetCatAll] = useState('All')
  const [searchText, setSearchText] = useState('')
  const [debouncedText] = useDebounce(searchText, 1000)
  const [pageCount, setPageCount] = useState(0)
  const [recordsTotal, setRecordsTotal] = useState(0)
  const [pageSkip, setPageSkip] = useState(0)
  const getCatCheck: any = slug || 'All'
  const pageNumberLimit = 10
  const getAllBlogs = () => {
    setLoading(true)
    ;(async () => {
      let query = ''
      if (searchText) {
        query += `&search=${debouncedText}`
      }

      if (getcat || slug) {
        query += `&category=${slug || getcat}`
      }

      await axios
        .get(
          `${process.env.NEXT_PUBLIC_API_URL}/api/blog/blogList?skip=${pageSkip}&limit=${pageNumberLimit}&column=createdOn&dir=desc${query}`
        )
        .then((res) => {
          setBlogData(res.data.data.records)

          const recordsTotals = res.data.data.recordsTotal
          const total = Math.ceil(recordsTotals) / pageNumberLimit
          setPageCount(total)
          setRecordsTotal(recordsTotals)
          setLoading(false)
        })

      await axios
        .get(`${process.env.NEXT_PUBLIC_API_URL}/api/category/list`)
        .then((res) => {
          setCategoryList(res.data.data)
          setLoading(false)
        })
    })()
  }

  useEffect(() => {
    AOS.init()
    getAllBlogs()
  }, [getCatAll, debouncedText, pageSkip, router.query.slug])

  const changePages = (event: { selected: number }) => {
    setPageSkip(event.selected)

    ref.current?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className="blog_listing mt-5 mt-xl-5" ref={ref}>
      <Container>
        <Tab.Container id="left-tabs-example" defaultActiveKey={getCatCheck}>
          <Row className="flex-md-row-reverse">
            <Col md={5}>
              <div className="blog_search_block ps-0 ps-lg-5 ms-0 ms-lg-5 mb-5 mb-lg-0">
                {/* <Form> */}
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Search for the blog"
                    onChange={(e) => {
                      setSearchText(e.target.value)
                    }}
                  />
                </Form.Group>
                {/* </Form> */}
                <Searchicon2 className="search_icon" />
              </div>
            </Col>
            <Col md={7}>
              <Nav className="flex--column tabStyle1 gap-3">
                <Nav.Item>
                  <Nav.Link
                    onClick={() => {
                      router.push(`/category/All`)
                      setLoading(true)
                    }}
                    className={slug === getCatAll ? 'active' : ''}
                  >
                    {getCatAll}
                  </Nav.Link>
                </Nav.Item>
                {categoryList?.map((getCat: BlogCategory) => (
                  <Nav.Item key={getCat.slug}>
                    <Nav.Link
                      className={slug === getCat.slug ? 'active' : ''}
                      onClick={() => {
                        router.push(`/category/${getCat.slug}`)
                        setLoading(true)
                      }}
                    >
                      {getCat.title}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="mt-5">
              <Tab.Content>
                <Tab.Pane
                  eventKey={getCatCheck}
                  className={getCatCheck ? 'active show' : ''}
                >
                  <div className="text-center">
                    {Loading && (
                      <Button variant="dark" disabled>
                        <Spinner
                          className=""
                          animation="border"
                          role="status"
                        />
                        Loading...
                      </Button>
                    )}
                  </div>
                  <Row className="align-items-stretch blog_listing_wrap">
                    {blogData.length > 0 && Loading === false
                      ? blogData.map((getBlog: BlogType) => (
                          <Col lg={6} className="mb-4" key={getBlog.slug}>
                            <div className="blog_item">
                              <div className="item_image">
                                <Link
                                  href={`/${getBlog.slug}`}
                                  className="title_sm text_black text-decoration-none">

                                  <img
                                    src={getBlog?.image}
                                    alt={getBlog?.title}
                                  />

                                </Link>

                                <div className="post_cat">
                                  {getBlog.categories.map((category, i) => (
                                    <React.Fragment key={i}>
                                      <Link
                                        key={category.title}
                                        href={`/category/${category.slug}`}
                                        role="button"
                                        tabIndex={0}
                                        className="text-decoration-none text_black"
                                        onClick={() =>
                                          router.push(
                                            `/category/${category.slug}`
                                          )
                                        }>

                                        {category.title}

                                      </Link>
                                      {getBlog.categories.length - 1 !== i && (
                                        <>, </>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </div>
                              </div>
                              <div className="p-3 p-xl-4">
                                {/* <div className="item_small_text mb-3">
                                  Written by
                                  <span className="text-primary ms-1">
                                    {getBlog.author
                                      ? getBlog.author
                                      : ' WebClues'}
                                  </span>
                                </div> */}
                                <h2 className="">
                                  <Link
                                    href={`/${getBlog.slug}`}
                                    className="block_title_sm text_black text-decoration-none">

                                    {getBlog?.title}

                                  </Link>
                                </h2>
                                <div className="item_desc text_para mb-3  blog_content_limit">
                                  <div
                                    dangerouslySetInnerHTML={createMarkup(
                                      getBlog?.description
                                    )}
                                  />
                                </div>
                                <div className="item_small_text">
                                  {moment(new Date(getBlog?.createdOn)).format(
                                    'MMMM DD, YYYY'
                                  )}
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))
                      : ''}
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>

      <Container className="pt-2 pt-xl-5">
        <Row>
          <Col xs={12} className="d-flex justify-content-center pt-4">
            <div className="pagination_style1 mb-0">
              <Pagination>
                <ReactPaginate
                  breakLabel="..."
                  pageRangeDisplayed={5}
                  previousLabel=""
                  previousClassName="prev page-item"
                  nextLabel=""
                  nextClassName="next"
                  pageCount={pageCount || 0}
                  onPageChange={changePages}
                  containerClassName="pagination_style1 mb-0 pagination"
                  pageClassName="page-item "
                  pageLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  disabledClassName="disabled"
                  activeClassName="active"
                />
              </Pagination>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

// export async function getStaticProps() {
//   return { props: { isErrorCls: true } }
// }

// export async function getStaticPaths({ params }) {
//   return {
//     paths: [{ params: { slug: path } }],
//     fallback: false, // can also be true or 'blocking'
//   }
// }

export default BlogListSection
